/** RTK Query cache tag types — keep in sync with apiSlice tagTypes. */
export const API_CACHE_TAGS = [
  'Task',
  'TaskHistory',
  'TaskWatcher',
  'Project',
  'ProjectMember',
  'User',
  'TimeEntry',
  'Comment',
  'Sprint',
  'Team',
  'Tenant',
  'AIUsage',
  'Feedback',
  'Webhook',
  'CustomField',
  'Usage',
  'Billing',
  'Waitlist',
  'Canvas',
  'Notification',
  'Dependency',
  'Milestone',
  'Wiki',
  'Economics',
  'OrgProducts',
  'OrgModules',
  'Code',
  'ProductAccess',
  'MyProductLicenses',
  'AdminLicenses',
  'Workspace',
  'Cost',
  'FollowUp',
] as const;
